<template>
  <div class="weeklist-wrap">
    <back-button :tag="false" />
    <div class="header">
      <van-row
        v-if="weeks && weeks.length > 0"
        class="search"
        gutter="15"
        type="flex"
        align="center"
      >
        <van-col>
          <div>选择周期</div>
        </van-col>
        <van-col>
          <div class="search-item" @click="weekPicker = true">
            <span>{{ weekText }}</span>
            <van-icon name="arrow-down" />
          </div>
        </van-col>
      </van-row>
      <div class="tips">
        温馨提示：每周各市前3名奖励20元现金红包，每周一
        由系统自动发放，请及时前往微信聊天中领取
      </div>
      <div v-if="list && list.length > 0" class="custom-thead">
        <van-row style="text-align: center">
          <van-col span="12">用户帐号</van-col>
          <van-col span="12">所在市</van-col>
        </van-row>
      </div>
    </div>
    <template v-if="list && list.length > 0">
      <div class="custom-table">
        <div class="custom-tbody stripe">
          <van-row
            v-for="(item, index) in list"
            :key="index"
            style="text-align: center"
          >
            <van-col span="12">{{ item.mobile }}</van-col>
            <van-col span="12">{{ item.city_name }}</van-col>
          </van-row>
        </div>
      </div>
    </template>
    <empty v-else />
    <van-popup
      v-model="weekPicker"
      round
      position="bottom"
      get-container="body"
    >
      <van-picker
        title=""
        show-toolbar
        :columns="weeks"
        @cancel="weekPicker = false"
        @confirm="weekConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import Empty from "./Empty";
import BackButton from "@/components/BackButton.vue";
export default {
  components: {
    Empty,
    BackButton,
  },
  data() {
    return {
      list: [],
      week: 1,
      weekText: "第 1 周",
      weekPicker: false,
      weeks: [],
    };
  },
  methods: {
    weekConfirm(value) {
      this.week = value.code;
      this.weekText = value.text;
      this.getRewardList();
      this.weekPicker = false;
    },
    async getWeekList() {
      try {
        const res = await this.$axios.post(`/Statis/week`);
        this.weeks = (res.data || []).map((item, index) => {
          return {
            code: item,
            text: "第  " + `${index + 1}` + "  周",
          };
        });
        this.weeks.reverse();
      } catch (error) {
        this.$notify({
          type: "danger",
          message: error.errorMsg || `获取周期数据失败`,
          duration: 2000,
        });
        this.$router.push("/");
      }
    },
    async getRewardList() {
      try {
        const res = await this.$axios.post(`/Statis/getStatsRegionTop3`, {
          week: this.week,
        });
        this.list = res?.data;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: error.errorMsg || `获取周榜数据失败`,
          duration: 2000,
        });
      }
    },
  },
  created() {
    this.getWeekList().then(() => {
      this.week = this.weeks[0]?.code;
      this.weekText = this.weeks[0]?.text;
      this.getRewardList();
    });
  },
};
</script>
<style lang="scss" scoped>
.weeklist-wrap {
  position: relative;
  padding-bottom: 40px;
  overflow: hidden;
  .header {
    position: fixed;
    top: 0;
    width: 100%;
  }
  .search {
    margin: 15px 20px;
    font-size: 14px;
    color: #333;
    .search-item {
      width: 230px;
      padding: 7px 10px;
      color: #999;
      cursor: pointer;
      border: 1px solid #c8c8c8;
      border-radius: 4px 4px 4px 4px;
      .van-icon-arrow-down {
        color: #3b60fc;
      }
      & > span {
        margin-right: 160px;
      }
    }
  }
  .tips {
    padding: 8px 20px;
    font-size: 14px;
    color: #00a3ff;
    background: rgba(0, 178, 255, 0.16);
  }
  .custom-thead {
    height: 15px;
    padding: 10px 0;
    font-size: 14px;
    line-height: 14px;
    color: #333;
    .van-col.left {
      text-align: left;
    }
    .van-col.center {
      text-align: center;
    }
    .van-col.right {
      text-align: right;
    }
  }
  .custom-table {
    height: calc(100vh - 40px - 100px - 25px);
    margin-top: 125px;
    overflow: auto;
    .week-title {
      padding-left: 15px;
      margin: 15px 0;
      font-size: 18px;
      font-weight: 600;
    }
    .custom-thead,
    .custom-tbody {
      .van-row {
        padding: 0 10px;
      }
    }

    .custom-tbody {
      padding-bottom: 0 !important;
    }
  }
}
</style>
